<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @notReturn="notReturnFun"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.search.name"
              placeholder="请输入固定资产名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.search.managerName"
              placeholder="请输入管理人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @allot="allotFun"
        @borrow="borrowFun"
        @breakage="breakageFun(arguments)"
        @transfer="transferFun"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 -->
    <add-dialog
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddVisible"
      @reloadData="loadTableData()"
    />

    <!-- 修改 -->
    <edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 调拨 -->
    <allot-dialog
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAllotVisible"
      @reloadData="loadTableData()"
    />

    <!-- 借用 -->
    <borrow-dialog
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogBorrowVisible"
      @reloadData="loadTableData()"
    />

    <!-- 报废|遗失 -->
    <breakage-dialog
      :data-id="id"
      dialog-title="固定资产报废|遗失"
      :dialog-visible.sync="dialogBreakageVisible"
      @reloadData="loadTableData()"
    />

    <!-- 转移 -->
    <transfer-dialog
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogTransferVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
    />

    <!-- 借用未还资产清单 -->
    <not-return-dialog
      :dialog-visible.sync="dialogNotReturnVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 新增
import addDialog from './components/addDialog'
// 修改
import editDialog from './components/editDialog'
// 调拨
import allotDialog from './components/allotDialog'
// 借用
import borrowDialog from './components/borrowDialog'
// 报损
import breakageDialog from './components/breakageDialog'
// 转移
import transferDialog from './components/transferDialog'
// 查看
import viewDialog from './components/viewDialog'
// 借用未还资产清单
import notReturnDialog from './components/notReturnDialog'
// 数据请求
import { listFixedAssetDataApi, exportFixedAssetDataApi, deleteFixedAssetApi } from '@/api/fixedAsset'

export default {
  name: 'FixedAsset',
  components: {
    CustomTable,
    TableOperation,
    addDialog,
    editDialog,
    allotDialog,
    borrowDialog,
    breakageDialog,
    transferDialog,
    viewDialog,
    notReturnDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'fixed_asset_detail', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['fixed_asset_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['fixed_asset_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['fixed_asset_edit'],
            prop: 'allot',
            label: '调拨',
            method: 'allot'
          },
          {
            permissionSigns: ['fixed_asset_edit'],
            prop: 'borrow',
            label: '借用',
            method: 'borrow'
          },
          {
            permissionSigns: ['fixed_asset_edit'],
            prop: 'breakage',
            label: '报废|遗失',
            method: 'breakage'
          },
          {
            permissionSigns: ['fixed_asset_edit'],
            prop: 'transfer',
            label: '转移管理人员',
            method: 'transfer'
          },
          {
            permissionSigns: ['fixed_asset_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['fixed_asset_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['fixed_asset_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            name: '',
            managerName: '',
          }
        },
        notPaging: true
      },
      todoList: [
        {
          permissionSigns: ['fixed_asset_edit'],
          label: '借用未还固定资产清单',
          method: 'notReturn',
        },
      ],
      // 选中的单据ID
      id: null,
      eventType: '',
      // 弹框组件标题名称
      dialogTitle: '',
      // 新增弹框组件
      dialogAddVisible: false,
      // 修改弹框组件
      dialogEditVisible: false,
      // 调拨弹框组件
      dialogAllotVisible: false,
      // 借用弹框组件
      dialogBorrowVisible: false,
      // 报损遗失弹框组件
      dialogBreakageVisible: false,
      // 管理人员移交弹框组件
      dialogTransferVisible: false,
      // 查看弹框组件
      dialogViewVisible: false,
      // 借用未还固定资产清单弹框组件
      dialogNotReturnVisible: false,
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'managerName', label: '管理人员', filterColumn: 'manager_name', width: 110 },
      { prop: 'name', label: '资产名称', filterColumn: 'name', width: 200 },
      { prop: 'unit', label: '计量单位', filterColumn: 'unit', width: 110 },
      { prop: 'configSpec', label: '规格配置信息', filterColumn: 'config_spec', minWidth: 200 },
      { prop: 'manageNumber', label: '管理数量', filterColumn: 'manage_number', width: 120, isBetween: true },
      { prop: 'lentNumber', label: '借出数量', filterColumn: 'lent_number', width: 120, isBetween: true },
      { prop: 'damageNumber', label: '损坏遗失数量', filterColumn: 'damage_number', width: 130, isBetween: true },
      { prop: 'operator', label: '操作人', filterColumn: 'operator', width: 100 },
      { prop: 'operateTimeValue', filterColumn: 'operate_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      listFixedAssetDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this;
      _this.eventType = 'add';
      _this.dialogTitle = '固定资产新增';
      _this.dialogAddVisible = !_this.dialogAddVisible;
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的固定资产', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogTitle = '固定资产修改'
      _this.dialogEditVisible = !_this.dialogEditVisible
    },
    // 调拨
    allotFun () {
      let _this = this
      _this.eventType = 'allot'
      _this.dialogTitle = '固定资产调拨'
      _this.dialogAllotVisible = !_this.dialogAllotVisible
    },
    // 借用
    borrowFun () {
      let _this = this
      _this.eventType = 'borrow'
      _this.dialogTitle = '固定资产借用'
      _this.dialogBorrowVisible = !_this.dialogBorrowVisible
    },
    // 报损
    breakageFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要报废或遗失的固定资产', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogBreakageVisible = !_this.dialogBreakageVisible
    },
    // 转移
    transferFun () {
      let _this = this;
      _this.eventType = 'transfer'
      _this.dialogTitle = '管理人员移交固定资产'
      _this.dialogTransferVisible = !_this.dialogTransferVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的固定资产', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 借用未还资产清单
    notReturnFun () {
      let _this = this
      _this.dialogNotReturnVisible = !_this.dialogNotReturnVisible
    },
    // 作废
    deleteFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的固定资产', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该固定资产？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteFixedAssetApi({ id: args[0].id }).then(response => {
          _this.$message({ message: response.message, type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let _this = this
      exportFixedAssetDataApi({ condition: JSON.stringify(_this.exportObj) }).then(response => {
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: true, url: response.data })
      })
    }
  }
}
</script>
